





/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// DELETEBLOGSECTION
// DELETEBLOGSECTION


const DELETEBLOGSECTION= createAsyncThunk(
  "deleteBlogSection/deleteBlogSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteBlogSectionSlice = createSlice({
  name: "deleteBlogSectionSlice",
  initialState: {
    deleteBlogSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteBlogSection: (state) => {
        state.deleteBlogSection.loading = false
        state.deleteBlogSection.error = false
        state.deleteBlogSection.data = []
        state.deleteBlogSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETEBLOGSECTION.fulfilled, (state, action) => {
      state.deleteBlogSection = {
        ...state.deleteBlogSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEBLOGSECTION.pending, (state, action) => {
      state.deleteBlogSection = {
        ...state.deleteBlogSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEBLOGSECTION.rejected, (state, action) => {
      state.deleteBlogSection = {
        ...state.deleteBlogSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteBlogSectionAction = {
    DELETEBLOGSECTION,
};

export { deleteBlogSectionAction };
export default deleteBlogSectionSlice.reducer;
export const {setInitialStateOfdeleteBlogSection} = deleteBlogSectionSlice.actions
